import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import CustomVariable from "../modules/CustomVariable";
import { setBotModule, setUsage } from "../../../actions";

export class BuilderVarEditor extends Component {
	constructor(props) {
		super(props);

		this.state = {
			variable: {
				name: "",
				reference: "",
				type: "text",
				dataType: "text",
				defaultValue: "",
				global: false
			},
			error: ""
		};
	}

	renderContent() {
		return (
			<div className="w-full max-w-[1400px] mx-auto px-[8px] py-[16px] sm:px-[16px] sm:py-[32px]">
				<div className="mb-6 sm:mb-8">
					<h2 className="text-2xl font-bold text-[#FFFFFF]">
						New Custom Variable
					</h2>
					<p className="text-[#9CA3AF] text-sm mt-1">
						Create a new Custom Variable. These can be used in your custom commands and events to store data.
					</p>
				</div>

				<div className="absolute top-[8px] right-[8px] sm:top-[16px] sm:right-[16px] z-[9999]">
					<button
						type="button"
						className="rounded-full bg-[#EF4444] p-[6px] text-[#FFFFFF] hover:bg-[#DC2626] transition-colors shadow-lg"
						onClick={this.props.close}
					>
						<svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
						</svg>
					</button>
				</div>

				{this.state.error && (
					<div className="mb-4 p-4 bg-[#EF4444] bg-opacity-10 border border-[#EF4444] rounded-md">
						<p className="text-[#EF4444] font-medium">{this.state.error}</p>
					</div>
				)}

				<div className="space-y-6">
					<section className="space-y-4">
						<CustomVariable
							darkMode={true}
							variable={this.state.variable}
							index="new"
							editVariable={(variable, index) => {
								if (index == "new") {
									var variables = { ...this.props.variables };

									var variable_settings = variables.variables.find((v) => v.reference == variable.reference);
									if (variable_settings) {
										return;
									}

									variables.variables.push(variable);
									this.props.setBotModule({
										module: "variables",
										module_data: variables
									});
									var newVariable = {
										name: "",
										reference: "",
										type: "text",
										dataType: "text",
										defaultValue: "",
										global: false
									};
									this.setState({
										variable: newVariable
									});
									this.props.close(variable.reference);
								}
							}}
						/>
					</section>
				</div>
			</div>
		);
	}

	render() {
		return (
			<Transition.Root show={this.props.showModal} as={Fragment}>
				<Dialog
					as="div"
					className="fixed inset-0 z-[9999] overflow-y-auto"
					onClose={this.props.close}
				>
					<Transition.Child
						as={Fragment}
						enter="ease-out duration-300"
						enterFrom="opacity-0"
						enterTo="opacity-100"
						leave="ease-in duration-200"
						leaveFrom="opacity-100"
						leaveTo="opacity-0"
					>
						<div className="fixed inset-0 bg-[#0000008a] transition-opacity" />
					</Transition.Child>

					<div className="fixed inset-0 overflow-y-auto">
						<div className="flex min-h-full items-start sm:items-center justify-center sm:p-[16px] text-center">
							<Transition.Child
								as={Fragment}
								enter="ease-out duration-300"
								enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
								enterTo="opacity-100 translate-y-0 sm:scale-100"
								leave="ease-in duration-200"
								leaveFrom="opacity-100 translate-y-0 sm:scale-100"
								leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
							>
								<Dialog.Panel className="w-full min-h-screen sm:w-screen sm:min-h-0 sm:max-w-[1000px] relative transform bg-[#141414] sm:rounded-lg text-left shadow-xl transition-all sm:my-8">
									<div className="h-full sm:h-auto p-0 sm:p-[24px]">
										{this.renderContent()}
									</div>
								</Dialog.Panel>
							</Transition.Child>
						</div>
					</div>
				</Dialog>
			</Transition.Root>
		);
	}
}

const mapStateToProps = (state) => ({
	variables: state.data.bot.commands.variables,
	user: state.data.user,
	premium: state.data.premium
});

const mapDispatchToProps = {
	setBotModule,
	setUsage
};

export default connect(mapStateToProps, mapDispatchToProps)(BuilderVarEditor);